module.exports = __webpack_public_path__ + "media/images/flags/16/Azerbaijan-81cd1d7e54d0516c2b868577f151a8d6.png";